<script setup lang="ts">
import { Tabs } from '@/shared/ui/Tabs'

import { useMalwareTabs, type MalwareTabName } from '../model/useMalwareTabs'

defineProps<{
  value: MalwareTabName
}>()

const { tabs, open } = useMalwareTabs()
</script>

<template>
  <Tabs :model-value="value" :tabs="tabs" @update:model-value="open" />
</template>
